import { Link } from 'react-router-dom';
import { categories } from '@/mocks/sites';
import { useTranslation } from 'react-i18next';

export default function CategoryGrid() {
  const { t } = useTranslation();

  const colorMap: Record<string, string> = {
    primary: 'bg-primary-100/70 text-primary-700',
    accent: 'bg-accent-100/80 text-accent-700',
    secondary: 'bg-secondary-100/80 text-secondary-700',
  };

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            网站分类导航
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            十大分类，覆盖生活、工作、学习全场景，快速定位你需要的网站
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-4 md:p-5 rounded-lg bg-background-100 hover:bg-background-200/70 border border-background-200/60 transition-all duration-200 cursor-pointer"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg mb-3 ${
                colorMap[cat.color] || colorMap.primary
              }`}>
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}